// Lib
import React, { ReactNode } from 'react';

// Utils
import { getElementId } from '../../../../../../common/elements/utils/elementPropertyUtils';

// Components
import RichTextTool from './RichTextTool';

// Hooks
import useInlineCommentTool from './useInlineCommentTool';

// Types
import { ToolbarToolProps } from '../../../config/toolDefinitions/toolbarToolTypes';
import { ImMNCurrentUser } from '../../../../../user/currentUserSelector';

type InlineCommentToolProps = ToolbarToolProps & {
    currentUser: ImMNCurrentUser;
    currentBoardId: string;
};

const InlineCommentTool = (props: InlineCommentToolProps): ReactNode => {
    const { selectedElements } = props;

    // No collapsed selection range is supplied, so the tool requires selected text
    const { isActive, canAddComment, toggleInlineComment } = useInlineCommentTool({
        parentElementId: getElementId(selectedElements?.first()),
    });

    return (
        <RichTextTool
            {...props}
            disabled={!isActive && !canAddComment}
            isActive={isActive}
            onClick={toggleInlineComment}
            iconName="toolbar-comment"
        />
    );
};

export default InlineCommentTool;
